export const ACTIVITY = 'ACTIVITY';
export const INTERACTIVE = 'INTERACTIVE';
export const COMPONENT = 'COMPONENT';
export const PATHWAY = 'PATHWAY';

export const WALKABLES = [
  ACTIVITY,
  INTERACTIVE,
];

export const ELEMENTS = [
  ACTIVITY,
  INTERACTIVE,
  COMPONENT,
  PATHWAY,
];
